import { CALL_API } from '../middleware';
import {
    FORCE_UPDATE,
    FORCE_UPDATE_SUCCESS,
    GET_DEVICES,
    GET_DEVICES_SUCCESS,
    MobileLoginBody,
    MOBILE_LOGIN,
    MOBILE_LOGIN_SUCCESS,
    RegisterDeviceReqBody,
    REGISTER_DEVICE,
    REGISTER_DEVICE_SUCCESS,
    RESET_DEVICE,
    RESET_DEVICE_SUCCESS,
    RESET_PIN,
    RESET_PIN_SUCCESS,
} from '../types/mobile';

export const registerDevice = (body: RegisterDeviceReqBody) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/registerDevice',
                method: 'POST',
                types: [REGISTER_DEVICE_SUCCESS, REGISTER_DEVICE],
                body,
            },
        });
    } catch (err) {
        throw err;
    }
};

export const mobileLogin = (body: MobileLoginBody) => async (dispatch: any) => {
    // console.log(JSON.stringify(body));
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/mobileLogin',
                method: 'POST',
                types: [MOBILE_LOGIN_SUCCESS, MOBILE_LOGIN],
                body,
            },
        });
    } catch (err) {
        throw err;
    }
};

export const onResetDevices = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/resetDevice',
                method: 'POST',
                types: [RESET_DEVICE_SUCCESS, RESET_DEVICE],
                body: { ...body, action: 'RESET_DEVICE' },
            },
        });
    } catch (err) {
        throw err;
    }
};

export const getDevices = (body: any) => async (dispatch: any) => {
    console.log(body);
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/getDevicesForUser',
                method: 'POST',
                types: [GET_DEVICES_SUCCESS, GET_DEVICES],
                body,
            },
        });
    } catch (err) {
        throw err;
    }
};

export const resetPin = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/resetpin',
                method: 'POST',
                types: [RESET_PIN_SUCCESS, RESET_PIN],
                body,
            },
        });
    } catch (err) {
        throw err;
    }
};

export const hardPushRequired = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/hardpushRequired',
                method: 'POST',
                types: [FORCE_UPDATE, FORCE_UPDATE_SUCCESS],
                body,
            },
        });
    } catch (err) {
        throw err;
    }
};
